import './bootstrap';

// Import everything from autoload
import './autoload/_lazysizes'
import './autoload/_smartresize'
import './autoload/_slick-carousel'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import pageBlockProjectsCarousel from './routes/blocks/projects-carousel';
import pageBlockImagesCarousel from './routes/blocks/images-carousel';
import pageBlockTextRowCarousel from './routes/blocks/text-row-carousel';
import pageBlockFeatureHighlights from './routes/blocks/feature-highlights';

/** Populate Router instance with DOM routes */
const routes = new Router({
	// All pages
	common,

	// Blocks
	pageBlockProjectsCarousel,
	pageBlockImagesCarousel,
	pageBlockTextRowCarousel,
	pageBlockFeatureHighlights
});

// Load Events
$(document).ready(() => routes.loadEvents());